import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { loadingTreasuryItem, searchAutoProducts } from 'actions'
import InputAutocomplete from 'components/form/inputAutocomplete'
import { Formik, FormikProps } from 'formik'
import { getInitValues, getValidationSchema } from 'lib/FieldValidations'
import { renderInput } from 'lib/FormUtils'
import { IProductItem } from 'models/Products'
import React, { Component, forwardRef, Ref } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import _ from 'underscore'
import {
	IndividualSearchForm,
	IndividualTreasurySearchProductProps,
	IndividualTreasurySearchProductState
} from './IndividualTreasuryType'

const noRenderInputs = ['sig_proceso', 'fin_item', 'modif_pcio', 'ind_stock']

export class IndividualTreasurySearchProduct extends Component<
	IndividualTreasurySearchProductProps,
	IndividualTreasurySearchProductState
> {
	firstRef: React.RefObject<any>
	autoInputRef: React.RefObject<any>

	constructor(props: IndividualTreasurySearchProductProps) {
		super(props)
		this.state = {
			auoptions: [],
			codUnidOptions: [],
			isLoading: false,
			productInfo: null
		}
		this.firstRef = React.createRef()
		this.autoInputRef = React.createRef()
	}

	componentDidMount(): void {
		this.setInitFocus()
	}

	componentDidUpdate(
		prevProps: Readonly<IndividualTreasurySearchProductProps>
	): void {
		const { search } = this.props
		if (search !== prevProps.search && search && search.productos) {
			const auoptions = search.productos.map((product) => ({
				id: product.niprod,
				label: product.desc_prod
			}))
			this.setState({ auoptions })
		}
	}

	/**
	 * to set foco in the search input
	 */
	setInitFocus = () => {
		this.firstRef.current.focus()
	}

	handleSearch = (search: string) => {
		const { idOperacion } = this.props
		this.props.searchAutoProducts({
			idOperacion,
			desc_prod: search,
			page_number: 0,
			page_size: 10
		})
	}

	handleSelect = (
		productSelected: any,
		props: FormikProps<IndividualSearchForm>
	) => {
		const { search } = this.props

		if (productSelected.length > 0) {
			const product = _.findWhere(search.productos, {
				niprod: productSelected[0].id
			})

			if (!_.isEmpty(product) && !_.isUndefined(product)) {
				for (const [key] of Object.entries(props.values)) {
					if (!noRenderInputs.includes(key)) {
						const inputValue = product[key as keyof IProductItem] || ''
						props.setFieldValue(key, inputValue)
					}
				}
			}

			this.setState({
				auoptions: [],
				productInfo: { ...product }
			})
		} else {
			this.setState({ codUnidOptions: [], productInfo: {}, auoptions: [] })
		}
	}

	handleChange = () => {}

	handlePreventClickAddCart = (props: FormikProps<IndividualSearchForm>) => {
		props.resetForm()
		this.handleAddCart(props.values)
		this.firstRef.current.clear()
		this.setInitFocus()
	}

	handleAddCart = (values: IndividualSearchForm) => {
		const { idOperacion } = this.props
		const { productInfo } = this.state

		this.props.loadingTreasuryItem({
			cantidad: values.cantidad,
			desc_prod: values.desc_prod,
			idOperacion: idOperacion,
			neto: values.neto,
			niprod: productInfo.niprod
		})

		this.autoInputRef.current.handleSelectedState(false)
	}

	/**
	 * to render all search inputs
	 * @returns render inputs
	 */
	renderSearchInputs = (props: FormikProps<IndividualSearchForm>) => {
		const { fields } = this.props
		const result: any = []

		if (!_.isEmpty(fields)) {
			fields.forEach((field, index) => {
				const fieldId = field.idCampo.trim()
				if (
					field.editable &&
					field.visible &&
					!noRenderInputs.includes(fieldId)
				) {
					field.colLabel = 'col-sm-4'
					field.colInput = 'col-sm-8'

					const colProps =
						fieldId === 'desc_prod' ? { lg: 3, md: 3, sm: 4, xs: 12 } : {}

					result.push(
						<Col className={'pr-0 pl-0 '} key={index} {...colProps}>
							{renderInput(field, props)}
						</Col>
					)
				}
			})
		}

		return result
	}

	render() {
		const { fields, t, formRef } = this.props
		const { auoptions, isLoading } = this.state
		const validationSchema = !_.isEmpty(fields)
			? getValidationSchema(fields, t, [])
			: {}

		const initialValues: any = getInitValues(fields)

		return (
			<Formik
				initialValues={initialValues}
				ref={formRef}
				onSubmit={(values: any, actions) => {
					actions.resetForm()
					this.handleAddCart(values)
					this.firstRef.current.clear()
					this.setInitFocus()
				}}
				validationSchema={validationSchema}
				enableReinitialize={true}
				render={(props: FormikProps<IndividualSearchForm>) => {
					const autoCompleteProps = {
						inputFormCol: { sm: 12 },
						label: false,
						inputId: 'search_product',
						name: 'search_product',
						placeholder: t('searchBox.form.insert_product'),
						fields,
						colLabel: 'col-sm-1',
						colInput: 'col-sm-12',
						handleSearch: this.handleSearch,
						auoptions: auoptions,
						handleLoading: isLoading,
						handleSelect: (selected: any) => this.handleSelect(selected, props),
						onChange: this.handleChange,
						labelKey: 'label',
						refs: this.firstRef,
						ref: this.autoInputRef
					}
					return (
						<Form onSubmit={(e) => props.handleSubmit(e as any)}>
							<Row>
								<Col lg={4} md={4} sm={6} xs={12} className={'pr-0'}>
									<InputAutocomplete {...autoCompleteProps} />
								</Col>
								{this.renderSearchInputs(props)}
								<Col md={'auto'} className={'mt-1 pl-0'}>
									<Button
										className={`btn btn-light`}
										onClick={() => this.handlePreventClickAddCart(props)}
									>
										<FontAwesomeIcon icon={faShoppingCart} />
									</Button>
								</Col>
							</Row>
						</Form>
					)
				}}
			/>
		)
	}
}

const mapStateToProps = ({ product }: any) => {
	const { searchAutoOptions } = product
	return {
		search: searchAutoOptions
	}
}

const mapDispatchToProps = { searchAutoProducts, loadingTreasuryItem }

const IndividualTreasurySearchProductWithRef = forwardRef(
	function IndividualTreasurySearchProductWrapper(
		props: IndividualTreasurySearchProductProps,
		ref: Ref<IndividualTreasurySearchProduct>
	) {
		return <IndividualTreasurySearchProduct {...props} ref={ref} />
	}
)

export default withTranslation('', { withRef: true })(
	connect(mapStateToProps, mapDispatchToProps, null, {
		forwardRef: true
	})(IndividualTreasurySearchProductWithRef)
)
